import { useEffect } from "react";
import { useAppSelector } from "redux/hooks";
import DriverService from "services/driver.service";
import SelectRedux from "components/molecules/ComboBoxRedux";
import PrivilegeService from "utils/privilege.util";

export default function SelectSearchDriverGroupAddress(props: any) {
	const { meta } = props;
	const driverGroupAddress = useAppSelector((state) => state.driver.driverGroupAddress);
	const permissions = useAppSelector((state) => state.auth?.user?.role_id?.permissions);

	useEffect(() => {
		if (PrivilegeService.checkPrivilege("driver:read", permissions)) {
			DriverService.getAllGroupTracking();
		}
	}, []);

	return <SelectRedux {...props} options={driverGroupAddress} />;
}
